import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/Card";
import { Input } from "@/components/ui/Input";
import { Button } from "@/components/ui/Button";

export default function StudentLogin() {
  const [params] = useSearchParams();
  const motivo = params.get("motivo");

  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // Pulisci eventuale token stantio (es. arrivo qui da 401 interceptor).
  useEffect(() => {
    localStorage.removeItem("jwt");
  }, []);

  async function handleSubmit(ev: React.FormEvent) {
    ev.preventDefault();
    setSending(true);
    setError(null);
    try {
      await api.post(`/auth/magic-link`, { email: email.trim() });
      setSent(true);
    } catch (e: any) {
      setError(e.message ?? "Errore invio link");
    } finally {
      setSending(false);
    }
  }

  if (sent) {
    return (
      <div className="min-h-screen flex items-center justify-center px-4">
        <Card className="max-w-md text-center space-y-3">
          <div className="text-5xl">📩</div>
          <h1 className="text-2xl font-serif text-primary">Link inviato</h1>
          <p className="text-secondary">
            Abbiamo inviato un link di accesso a<br />
            <strong className="text-primary font-mono">{email}</strong>
          </p>
          <p className="text-xs text-muted font-mono pt-2">
            Valido per 15 minuti. Controlla anche la cartella spam.
          </p>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <Card className="max-w-md w-full space-y-5">
        <header className="space-y-1">
          <div className="font-mono text-xs uppercase tracking-wider text-secondary">
            Area studente
          </div>
          <h1 className="text-3xl font-serif text-primary">Accedi</h1>
        </header>

        {motivo === "session_expired" && (
          <div className="bg-blue/20 border border-blue/40 rounded-xl p-3 text-sm text-primary">
            La tua sessione è scaduta.{" "}
            <strong>Le tue risposte sono state salvate.</strong>
          </div>
        )}
        {motivo === "unauthorized" && (
          <div className="bg-accent/20 border border-accent/40 rounded-xl p-3 text-sm text-primary">
            Sessione non valida. Accedi di nuovo per continuare.
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <Input
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="tu@esempio.it"
            autoFocus
            required
          />

          {error && (
            <div className="bg-red-500/10 border border-red-500/40 rounded-xl p-3 text-sm text-red-300">
              {error}
            </div>
          )}

          <Button type="submit" loading={sending} className="w-full">
            Ricevi link di accesso
          </Button>
        </form>

        <p className="text-xs text-muted text-center font-mono">
          Riceverai un link via email. Nessuna password.
        </p>
      </Card>
    </div>
  );
}
